import { Injectable } from '@angular/core';
import { AbstractListViewService } from '@y42/core/list-view';
import { AbstractJobService } from '@y42/job';
import { ImportWriteType } from '@y42/json-schema';
import { combineLatest, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { JobWithDataTestsHttpModel, JobWithDataTestsUIModel } from '../../model/job.model';
import { DataTestDialogStateService } from '../data-test-dialog/data-test-dialog-state.service';
import { DataTestJobOverviewListUIModel } from './data-test-job-overview-list.model';

@Injectable()
export class DataTestJobOverviewListViewService extends AbstractListViewService<DataTestJobOverviewListUIModel> {
  constructor(
    private readonly jobService: AbstractJobService<JobWithDataTestsHttpModel, JobWithDataTestsUIModel>,
    private readonly dataTestDialogStateService: DataTestDialogStateService,
  ) {
    super();
  }

  readonly data$: Observable<DataTestJobOverviewListUIModel[]> = combineLatest([
    this.jobService.jobs$,
    this.dataTestDialogStateService.path$,
  ]).pipe(
    // select those with tests
    map(([jobs, path]) => jobs.filter((job) => job.tests && job.tests.length > 0 && job.path === path)),
    map(this.toListViewUIModel),
  );
  readonly loading$: Observable<boolean> = of(false); // don't show loading indicator to speed up interface

  private toListViewUIModel(jobUIModel: JobWithDataTestsUIModel[]): DataTestJobOverviewListUIModel[] {
    return jobUIModel
      .map((job) =>
        (job.tests ?? []).map((test): DataTestJobOverviewListUIModel => {
          return {
            id: job.request_id,
            request_id: job.request_id,
            error: job.error,
            company_id: job.company_id,
            test: test,
            write_disposition: job.details.write_disposition ?? ImportWriteType.Truncate,
          };
        }),
      )
      .flat();
  }
}
